import React from "react";
import { FaGithub, FaLinkedin, FaChevronDown } from 'react-icons/fa';
import { motion } from "framer-motion";
import Header from "./component/Header";
import Footer from "./component/Footer";
import Projects from "./subPages/Projects";
import AboutMe from "./subPages/AboutMe";
import Skills from "./subPages/Skills";
import Contactme from "./subPages/Contactme";

export default function App() {
  return (
    <>
     <Header />
     <main className="bg-white text-white min-h-screen font-sans">

      <section
        id="home"
        className="h-screen grid grid-cols-1 md:grid-cols-2 gap-10 items-center px-6 md:px-20 bg-cover bg-center mb-20 md:mb-0"
        style={{ backgroundImage: "url('/images/bg.png')" }}
      >
        {/* Left - Text Content */}
        <div className="text-center md:text-left flex flex-col justify-center items-center md:items-start">
          <motion.h1
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="text-3xl md:text-6xl font-bold text-[#3d2b1f] font-lobster"
          >
            Hi, I'm Nimrekha
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 1 }}
            className="text-base md:text-xl mt-4 text-black max-w-md"
          >
          I am a QA Engineer with a background in Software Engineering and experience in both software quality assurance and software development. So, I am eager to take on new challenges while delivering high-quality, reliable software through effective testing, problem-solving, and collaboration. 
          </motion.p>

          <motion.div
            className="flex flex-col md:flex-row items-center md:items-start mt-6 space-y-3 md:space-y-0 md:space-x-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 1 }}
          >
            <a
              href="#projects"
              className="px-6 py-3 bg-[#987654] text-black rounded-full font-medium hover:bg-[#c19a6b] transition"
            >
              View My Projects
            </a>
            <a
              href="#contact"
              className="px-6 py-3 bg-[#a0522d] text-black rounded-full font-medium hover:bg-[#c19a6b] transition"
            >
              Get in Touch
            </a>
          </motion.div>


          {/* Icons */}
          <motion.div
            className="flex justify-center md:justify-start mt-6 space-x-6 text-2xl"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.9, duration: 1 }}
          >
            <a href="https://github.com/WeerasingheN-T" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400 text-[#321414]">
              <FaGithub />
            </a>
            <a href="https://www.linkedin.com/in/nimrekha-weerasinghe-868283227/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400 text-[#321414]">
              <FaLinkedin />
            </a>
          </motion.div>
        </div>

        {/* Right - Image */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
          className="flex justify-center"
        >
          <img
            src="/images/profile1.jpg"
            alt="Nimrekha"
            className="rounded-full w-60 sm:w-60 md:w-80 lg:w-96 object-cover shadow-2xl drop-shadow-lg" />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 0 }}
          animate={{ opacity: 1, y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="absolute bottom-10 left-1/2 transform -translate-x-1/2 cursor-pointer"
        >
          <a href="#about">
            <FaChevronDown className="text-3xl text-[#987654] hover:text-[#c19a6b]" />
          </a>
        </motion.div>
      </section>

      <AboutMe />


      {/* Projects Section */}
      <Projects />

      <Skills />

      <Contactme />

      <Footer/>
    </main></>
  );
}
